var App = App || {};

App.components = {

	register_in: function(component) { // this = el
		if (!this.dataset.format) return;
		if (!this.tpl_format) {
			this.tpl_format = this.dataset.format;
			this.tpl_data = JSON.parse(this.dataset.data);
			if (this.dataset.task) {
				let id_task = parseInt(this.dataset.task);
				if (!component.list_by_object[id_task]) component.list_by_object[id_task] = [];
				component.list_by_object[id_task].push(this);
			} else if (this.dataset.project) {
				let id_project = parseInt(this.dataset.project);
				if (!component.list_by_object[id_project]) component.list_by_object[id_project] = [];
				component.list_by_object[id_project].push(this);
			} else if (this.dataset.user) {
				let id_user = parseInt(this.dataset.user);
				if (!component.list_by_object[id_user]) component.list_by_object[id_user] = [];
				component.list_by_object[id_user].push(this);
			}
			delete this.dataset.data;
			delete this.dataset.format;
		}
		component.list_all.push(this);
	},

	unregister_in: function(component) { // this = el
		if (this.dataset.task) {
			let id_task = parseInt(this.dataset.task);
			component.list_by_object[id_task] = component.list_by_object[id_task].filter((el) => el !== this);
		} else if (this.dataset.project) {
			let id_project = parseInt(this.dataset.project);
			component.list_by_object[id_project] = component.list_by_object[id_project].filter((el) => el !== this);
		} else if (this.dataset.user) {
			let id_user = parseInt(this.dataset.user);
			component.list_by_object[id_user] = component.list_by_object[id_user].filter((el) => el !== this);
		}
		component.list_all = component.list_all.filter((el) => el !== this);
	},

	helper_need_update: function (html1, html2) {
		html1 = html1.replace(/(<ws-icon[^>]*>).*?<\/ws-icon>/gs, '$1');
		html2 = html2.replace(/(<ws-icon[^>]*>).*?<\/ws-icon>/gs, '$1');
		return html1 !== html2;
	},

	init: function() {
		for (let i in App.components) {
			if ('define' in App.components[i]) App.components[i].define();
		}
	},

	onload: function() {
		for (let i in App.components) {
			if ('onload' in App.components[i]) App.components[i].onload();
		}
	},
}
$(document).on('page_onload.once', () => App.components.onload());
$(document).ready( () => App.components.init());
// App.components.init();

$.fn.destroyComponents = function () {
	for (let i in App.components) {
		if ('destructor' in App.components[i]) this.find(App.components[i].tag_name).each(function() {
			App.components[i].destructor.call(this, App.components[i])
		});
	}
	return this;
};

$.fn.removeWithComponents = function () {
	return this.destroyComponents().remove();
};

$.fn.cloneWithComponents = function () {
	for (let i in App.components) {
		this.find(App.components[i].tag_name).each(function() {
			$(this).attr('data-format', this.tpl_format);
			$(this).attr('data-data', JSON.stringify(this.tpl_data));
		});
	}
	let o = this.clone();
	for (let i in App.components) {
		this.find(App.components[i].tag_name).each(function() {
			$(this).removeAttr('data-format').removeAttr('data-data');
		});
	}
	return o;
};